import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Chip, Typography} from '@mui/material';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../layouts/theme/designSystem';
import {Skill} from '../../types/shared-types';

interface Props {
  skills?: Skill[];
}
export const SkillDetails = ({skills}: Props) => {
  const {t} = useTranslation();
  const lang = useContext(LanguageContext);

  return (
    <>
      <Typography
        variant='h3'
        sx={{
          margin: '32px 0 16px 0',
        }}
      >
        {t('companyJobPostings.newJobDialog.formLabels.skills')}
      </Typography>
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: '0.5rem', margin: '18px'}}>
        {skills?.map((skill) => (
          <Chip
            key={`skill-${skill.name}-${skill.resourceId}`}
            label={<Typography variant='body1'>{`${skill.name[lang]}`}</Typography>}
            sx={{
              borderRadius: '2px',
              backgroundColor: orangeColors[5],
              padding: '24px',
              width: 'fit-content',
            }}
          />
        ))}
      </Box>
    </>
  );
};
